import { render } from "./AuthorInputPage.vue?vue&type=template&id=f35f0fb2&scoped=true&ts=true"
import script from "./AuthorInputPage.vue?vue&type=script&lang=ts"
export * from "./AuthorInputPage.vue?vue&type=script&lang=ts"

import "./AuthorInputPage.vue?vue&type=style&index=0&id=f35f0fb2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35f0fb2"]])

export default __exports__